import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {DomainUtilService} from '../../../util/domain-util.service';
import {TopLevelDomain} from '@iana-rzms/bff-sdk';
import {ChangeVO} from '../../../generate/ChangeVO';
// TODO(RZ-2562): Replace legacy VO types (OrganizationVO) with SDK equivalents (Organization)
import {OrganizationVO} from '../../../generate/OrganizationVO';

@Component({
    selector: 'sponsoring-org',
    templateUrl: './sponsoring-org.component.html',
    styleUrls: ['./sponsoring-org.component.scss'],
    standalone: false
})
export class SponsoringOrgComponent implements OnInit {

  @Input()
  lastchange: string;
  @Input()
  domain: TopLevelDomain;
  @Input()
  pendingRequestChangeID: string;
  @Output()
  modifiedTLDOutput = new EventEmitter<TopLevelDomain>();
  @Input()
  change: ChangeVO;
  @Input()
  viewMode: boolean;
  @Input()
  hasNonTechnicalPermission: boolean;

  editmode: boolean;

  constructor(private domainUtil: DomainUtilService) {
  }

  ngOnInit() {
  }

  edit(val) {
    this.editmode = val;
  }

  cancel(val) {
    this.edit(false);
  }

  sponsoringOrgOutput(organizationVO: OrganizationVO) {
    this.modifiedTLDOutput.emit(this.domain);
    this.edit(false);
  }

  getSONameBasedOnType(): string {
    return this.domainUtil.getSONameBasedOnType(this.domain);
  }

}
